import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {bindActionCreators} from "redux";
import {fetchTags} from "../../tags/actions";
import Link from "../../routing/components/Link";

class Headpart extends React.Component {
  constructor(props) {
    super(props);
    this.language = props.intl.locale;
  }

  getSameUrlForLanguage(currentPath, currentLanguage, newlanguage) {
    return (currentPath.replace("/" + currentLanguage, "/" + newlanguage));
  }


  render() {
    return (
      <div>
        <header className="navbar navbar-default container" id="navbar" role="banner">
          <div className="navbar-collapse">
            <div className="region region-navigation-collapsible">
              <section
                className="language-switcher-language-url block block-language block-language-blocklanguage-interface clearfix"
                id="block-languageswitcher" role="navigation">
                <a href={this.getSameUrlForLanguage(this.props.path, this.props.intl.locale, "nl")} className={"language-link" + isActive('nl', this.props.intl.locale)} hrefLang="nl"
                   data-drupal-link-system-path="<front>">NL</a>
                <a href={this.getSameUrlForLanguage(this.props.path, this.props.intl.locale, "fr")} className={"language-link" + isActive('fr', this.props.intl.locale)} hrefLang="fr" data-drupal-link-system-path="<front>">FR</a>
                <a href={this.getSameUrlForLanguage(this.props.path, this.props.intl.locale, "de")} className={"language-link" + isActive('de', this.props.intl.locale)} hrefLang="de" data-drupal-link-system-path="<front>">DE</a>
              </section>

              <nav role="navigation" aria-labelledby="block-senaat-bootstrap-main-menu-menu"
                   id="block-senaat-bootstrap-main-menu">
                <ul className="menu nav navbar-nav">
                  <li className="expanded dropdown">
                    <a href={"/" + this.language} data-drupal-link-system-path="" className="is-active">Home</a>
                  </li>
                  {/*<li className="expanded dropdown">*/}
                  {/*  <a href={"/" + this.language + "/dia/structure"}><FormattedMessage id="lawTexts"/></a>*/}
                  {/*</li>*/}
                  <li className="expanded dropdown">
                    <Link url={"/" + this.language + "/dia/structure"} to={"/" + this.language + "/dia/structure"}><FormattedMessage id="lawTexts"/></Link>
                  </li>
                  <li className="expanded dropdown">
                    <a href={"/" + this.language + "/dia/tags"}><FormattedMessage id="tags"/></a>
                  </li>
                  <li className="expanded dropdown">
                    <a href={"/" + this.language + "/about"} data-drupal-link-system-path="node/1"><FormattedMessage id="aboutMenu"/></a>
                  </li>
                  <li className="expanded dropdown">
                    <a href={"/" + this.language + "/contact"} data-drupal-link-system-path="contact">Contact</a>
                  </li>
                </ul>
              </nav>

              <div className="brand-break"></div>
              <div className="row" style={{marginTop: 70}}>
                <div className="col-xs-1 col-logo">
                  <a className="logo navbar-btn pull-left" href="/nl" title="Home" rel="home">
                    <img src="/assets/sites/default/files/crown.png" alt="Home" style={{maxHeight: 55}}/>
                  </a>
                </div>
                <div className="col-sm-11 navbar-name">
                  <a className="name navbar-brand" href="/nl" title="Home" rel="home">SenLex</a>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>


      );
  }
}

Headpart.propTypes = {
  intl: React.PropTypes.object.isRequired
};

function isActive (language, locale) {
  let isactive = "";
  if (language == locale)
    isactive = " is-active";
  return isactive;
}
function mapStateToProps(state) {
  const {intl} = state;
  console.log("Headpart: Binnen mapStateToProps")
  return {
    intl
  };
}

function donothing (dispatch) {
  return "";
}

function mapDispatchToProps(dispatch) {
  console.log("Binnen mapDispatchToProps")
  return {
    donothing: bindActionCreators(donothing, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Headpart);



/** WEBPACK FOOTER **
 ** ./src/modules/app/components/Headpart.js
 **/